import { createBrowserHistory } from "history";
import { isBSP, isMicroApp } from "utils/microApp";

const getBasename = () => {
  if (isMicroApp) {
    if (isBSP) {
      return "/";
    } else {
      return "/new/marketing-center/affiliate";
    }
  }
  return "/";
};

const history = createBrowserHistory({
  basename: getBasename(),
});

export default history;
